$(document).ready(function () {
  const $scrollers = $('.is-style-workflow-panel');
  const $scrollBys = $('.wp-block-acf-workflow__step');

  // --- 1. Initial State Activation ---
  $scrollers.each(function (index) {
    $(this).attr('data-panel', index);
  });

  // Automatically show the first panel right away on page load
  $scrollers.first().addClass('active');

  // --- 2. Scroll Engine ---
  $(window).on('scroll', function () {
    // Add half the window height so the trigger point tracks the center of the user's screen
    const scrollTriggerLine = $(window).scrollTop() + ($(window).height() / 2);
    let targetNumber = null;

    $scrollBys.each(function () {
      const $scrollBy = $(this);
      const elementTop = $scrollBy.offset().top;

      // The transition point is now exactly the top boundary of each step element
      if (scrollTriggerLine >= elementTop) {
        targetNumber = $scrollBy.attr('data-step');
      } else {
        // Break out of the loop early since steps are ordered top-to-bottom
        return false;
      }
    });

    // Update classes based on the dynamic position results
    if (targetNumber !== null) {
      $scrollers.removeClass('active');
      const $activeScroller = $(`.is-style-workflow-panel[data-panel="${targetNumber}"]`);

      if ($activeScroller.length) {
        $activeScroller.addClass('active');
      }
    } else {
      // Fallback: If scrolled back above everything, force the first panel active
      $scrollers.removeClass('active');
      $scrollers.first().addClass('active');
    }
  });
});
